export default [
    {
        value: 'Coordenador',
        text: 'Coordenador'
    },
    {
        value: 'Gerente',
        text: 'Gerente'
    },
    {
        value: 'Pesquisador',
        text: 'Pesquisador'
    },
    {
        value: 'AuxiliarTecnico',
        text: 'Auxiliar técnico'
    },
    {
        value: 'AuxiliarTecnicoBolsista',
        text: 'Auxiliar técnico bolsista'
    },
    {
        value: 'AuxiliarAdministrativo',
        text: 'Auxiliar administrativo'
    },
]